import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import { useScrollLock } from '@vueuse/core'

// Components
import Button from '@/components/ui/Button'

// i18n
import { useI18n } from 'vue-i18n'
import { useVideoStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Video',
  setup(__props) {

const { t } = useI18n()

// Store
const videoStore = useVideoStore()

// Data
const body = ref<HTMLElement | null>(document.body)
const isLocked = useScrollLock(body)

// Computed
const isOpened = computed<boolean>(() => Boolean(videoStore.type))

// Watch
watch(() => isOpened.value, (val) => {
  isLocked.value = Boolean(val)
})


return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["video", {'video_show': isOpened.value}]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(videoStore).closeVideo()))
    }, [
      _createElementVNode("div", {
        class: "video__wrapper",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_unref(Button), {
          class: "video__close",
          theme: "icon-padding",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(videoStore).closeVideo()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draw_svg, {
              name: "close",
              width: "15",
              height: "15"
            })
          ]),
          _: 1
        }),
        (isOpened.value)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              src: _unref(videoStore).link,
              width: "100%",
              height: "100%",
              frameborder: "0",
              allow: "accelerometer; autoplay; gyroscope; fullscreen;",
              allowfullscreen: ""
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})